import classNames from 'classnames'
import { HTMLAttributes } from 'react'
import { FileError } from 'react-dropzone'

interface Props extends HTMLAttributes<HTMLDivElement> {
  progress: number
  height?: string
  errors?: FileError[]
}

export const ProgressBar = ({ progress, height, errors, ...rest }: Props) => {
  return (
    <div
      className={classNames('bg-gray-300 w-full  rounded-full h-1', {
        'bg-red': errors && errors.length !== 0,
        [height]: height
      })}
      {...rest}
    >
      <div
        className={classNames('bg-v2-bleu-de-france h-1 rounded-full', {
          [height]: height
        })}
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  )
}
